import api from "PFCore/api";
import { ActivityCustomField, Collection, Id, SkillsFramework, SkillsFrameworkRank } from "PFTypes";
import { MergeExclusive } from "type-fest";

export type SkillsFrameworksOptionsResponse = Collection<SkillsFramework[]>;

export type FetchSkillsFrameworksOptionsParams = {
  availableInDemand?: boolean;
  ids?: Id[];
  perPage?: number;
  rank?: SkillsFrameworkRank;
} & MergeExclusive<{ recommendationTerm?: string; customFields?: ActivityCustomField[] }, { term?: string }>;

export const fetchSkillsFrameworksOptions = (
  params: FetchSkillsFrameworksOptionsParams = {}
): Promise<SkillsFrameworksOptionsResponse> =>
  api({
    url: "options/skills_frameworks",
    params
  });
